import { Alert } from "react-bootstrap";
import * as icons from "react-bootstrap-icons";

const ICONS = {
  info: icons.InfoCircleFill,
  warning: icons.ExclamationTriangleFill,
  danger: icons.ExclamationOctagonFill,
};

/**
 * MG-014 / AD-013 (#167, #168): an alert on the Broadcasting Center pages, in the design's style - a
 * pale background, a coloured left edge and the variant's icon, with `title` (if any) leading in bold.
 *
 * The text sits in one element: the alert lays out as a flex row, which would otherwise make each
 * text node and link a separate item and drop the spaces between them.
 *
 * @param {{variant: "info"|"warning"|"danger", title?: string, children: React.ReactNode}} props Any
 *   other prop (dismissible, onClose, role) goes to react-bootstrap's Alert.
 */
export const BroadcastAlert = ({ variant, title, children, ...props }) => {
  const Icon = ICONS[variant];
  return (
    <Alert variant={variant} className="broadcast-alert" {...props}>
      <Icon className="broadcast-alert-icon" aria-hidden="true" />
      <div>
        {title && (
          <>
            <b>{title}</b>{" "}
          </>
        )}
        {children}
      </div>
    </Alert>
  );
};
